import { first } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { TokenService } from 'src/app/services/common/token.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { DashboardService } from 'src/app/services/dashboard.service';

@Component({
  selector: 'app-vendor-mi-estimation-consent-form',
  templateUrl: './vendor-mi-estimation-consent-form.component.html',
  styleUrls: ['./vendor-mi-estimation-consent-form.component.scss']
})
export class VendorMiEstimationConsentFormComponent implements OnInit {

  items: any[];
  selectedStatus: any;
  remarks: String;
  appId: String;
  vendorId: String;
  programId: String;
  applicationDetails: any;
  isActionSectionEnabled: boolean;

  public isProDataCalculated: boolean = false;
  public proCalculatedData: any;
  public statusCode: any;
  public userID: any;
  public preEstimateDetails: any;
  public showMap: any;
  public options: any;
  public overlays: any[];

  public cropType: any;
  public selectedCropType: any;
  public selectedCrop: any;
  public currentDateTime: any;

  public preEstimationDataArray: any = [];

  optionsPreEstimate: any;
  overlaysPreEstimate: any[];
  showMapPreEstimate: any;

  constructor(
    private deptDashBoardService: DepartmentDashboardService, 
    private messageService: MessageService, 
    private vendorService: VendorDashboardService, 
    private router: Router, 
    private route: ActivatedRoute, 
    private tokenService: TokenService, 
    private cryptoJsService: CryptoJsService,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private _dashboardService: DashboardService,
    ) { }

  ngOnInit(): void {
    this.appId = this.route.snapshot.paramMap.get('appId');
    this.vendorId = this.route.snapshot.paramMap.get('vendorId');
    this.programId = this.route.snapshot.paramMap.get('programId');

    this.currentDateTime = new Date();

    this.getCropMaster();
    this.getApplicationDetails(this.appId);

    // console.log('appId', this.appId)
    // console.log('vendorId', this.vendorId)
    // console.log('programId', this.programId)

    this.route.queryParams
      .subscribe(params => {
        this.statusCode = this.cryptoJsService.DecryptData(params.statusCode);
        if (params.statusCode == this.cryptoJsService.Encrypt('C') || params.statusCode == this.cryptoJsService.Encrypt('P')) {
          this.isActionSectionEnabled = true;
        } else {
          this.isActionSectionEnabled = false;
        }
      }
      );

    // console.log("statuscode ",this.statusCode)
    // console.log("statuscode ",this.cryptoJsService.DecryptData(this.statusCode))

    // if (this.appId && this.programId) {
    //   this.deptDashBoardService.getApplicationDataOfPreEstimation(this.appId, this.programId)
    //     .pipe(first())
    //     .subscribe({
    //       next: (data) => {
    //         this.preEstimateDetails = data;

    //         if(this.preEstimateDetails.CropTypeID && this.preEstimateDetails.CropId){
    //           this.cropType.forEach((res) => {
    //             if (res.data === data.CropTypeID) {
    //               this.selectedCropType = res.label;
    //               let crop = res.children;
    //               crop.forEach((res2) => {
    //                 if(res2.data === data.CropId){
    //                   this.selectedCrop = res2.label;
    //                 }
    //               })
    //               return;
    //             }
    //           });
    //         }


    //         if( this.preEstimateDetails.listGPSCoordinates.length>0){
    //           this.showMap=true;
    //           let locationArray = []
    //         this.preEstimateDetails.listGPSCoordinates.forEach(e => {
    //           locationArray.push({ lat: e.Latitude, lng: e.Longitude })
    //         })
    //         this.options = {
    //           center: { lat: locationArray[0].lat, lng: locationArray[0].lng },
    //           zoom: 12,
    //           mapTypeId: google.maps.MapTypeId.SATELLITE
    //         };
    //         let pointLocations = [];
    //         locationArray.forEach(e => { pointLocations.push(new google.maps.Marker({ position: { lat: e.lat, lng: e.lng } })) });
    //         this.overlays = [
    //           ...pointLocations,
    //           new google.maps.Polygon({
    //             paths: [...locationArray], strokeOpacity: 0.5, strokeWeight: 1, fillColor: '#1976D2', fillOpacity: 0.35
    //           }),


    //         ];
    //         }
    //         else{
    //           this.showMap=false;
    //         }
            
    //       },
    //       error: () => {
    //         // this.loader.close();
    //         // this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data Error : Vendor Consent Form Not Loaded' });
    //       }
    //     });
    // }

    if (!this.appId && !this.vendorId && !this.programId) {
      this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data Error : Cannot Load Form Due to Missing Parameters' });
    }
    let sessionToken = sessionStorage.getItem('token');
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
    this.activityRecordService.activityRecord(this.userID, 'View Vendor MI Estimation For Approval', this.appId, new Date(), 'Success');

    let actionId = 14; // Do not Change, it is fixed for Farmer Application Verifications
    this.loader.start();
    this.deptDashBoardService.GetStatusMaster(JSON.parse(payload)?.sub, actionId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.items = data.$values;
          this.loader.close();
        },
        error: () => {
          this.loader.close();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Status Master cant be Loaded' });
        }
      });

    this.loader.start();
    this.deptDashBoardService.getVendorMIEstimation(this.appId, this.vendorId, this.programId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.applicationDetails = data;
          this.loader.close();
        },
        error: () => {
          this.loader.close();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data Error : Vendor Consent Form Not Loaded' });
        }
      });

  }

  handleClick() {
    let sessionToken = sessionStorage.getItem('token');
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);

    this.loader.start();
    this.deptDashBoardService.insertVendorMIEstimateForApproval(this.appId, JSON.parse(payload)?.sub, this.remarks, this.selectedStatus.flag, this.programId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.activityRecordService.activityRecord(this.userID, 'Submit Approval', this.appId, new Date(), this.selectedStatus.status);
          let resp = JSON.stringify(data);
          if (resp.startsWith('"S')) {
            this.messageService.add({
              severity: 'success',
              summary: 'Status',
              detail: resp,
            });
          }
          else {
            this.messageService.add({
              severity: 'error',
              summary: 'Status',
              detail: resp,
            });
          }

          if (data == 'S:Successfully Submitted' || 'S:Successfully Updated') {

            let componentName = window.sessionStorage.getItem('currentComponentName');

            if (sessionStorage.getItem('userRole') == 'DD Associate') {

              // let applications = JSON.parse(window.sessionStorage.getItem("miVendorApplicationForApproval"));
              let applications = JSON.parse(window.sessionStorage.getItem(componentName));
              applications.filter(application => {
                return application.AppID === this.appId
              }).forEach(element => {
                // element.Status_Ar = this.selectedStatus.flag == 'A' ? 'A' : 'C',
                element.Status_Ar = 'C',
                  element.Status = this.selectedStatus.flag == 'A' ? 'Approved' : (this.selectedStatus.flag == 'RP') ? 'Return Process' : (this.selectedStatus.flag == 'R') ? 'Rejected' : 'Marked Return',
                  element.NextLevelID = 'DDMICADA',
                  element.Remarks = this.remarks

              });
              // sessionStorage.setItem('miVendorApplicationForApproval', JSON.stringify(applications));
              sessionStorage.setItem(componentName, JSON.stringify(applications));

            } else if (sessionStorage.getItem('userRole') == 'DDMICADA') {

              // let applications = JSON.parse(window.sessionStorage.getItem("miVendorApplicationForApproval"));
              let applications = JSON.parse(window.sessionStorage.getItem(componentName));
              applications.filter(application => {
                return application.AppID === this.appId
              }).forEach(element => {

                let nextLevelId;
                if (this.selectedStatus.flag == 'A') {
                  nextLevelId = 'DMICADA';
                } else if (this.selectedStatus.flag == 'RP') {
                  nextLevelId = 'Vendor'
                } else if (this.selectedStatus.flag == 'R') {
                  nextLevelId = 'N/A'
                }

                element.Status_Ar = this.selectedStatus.flag == 'A' ? 'A' : 'C',
                element.Status_Ar = 'C',
                  element.Status = this.selectedStatus.flag == 'A' ? 'Approved' : (this.selectedStatus.flag == 'RP') ? 'Return Process' : (this.selectedStatus.flag == 'R') ? 'Rejected' : 'Marked Return',
                  element.NextLevelID = nextLevelId,
                  element.Remarks = this.remarks

              });
              // sessionStorage.setItem('miVendorApplicationForApproval', JSON.stringify(applications));
              sessionStorage.setItem(componentName, JSON.stringify(applications));
            }
            else if (sessionStorage.getItem('userRole') == 'DMICADA') {

              // let applications = JSON.parse(window.sessionStorage.getItem("miVendorApplicationForApproval"));
              let applications = JSON.parse(window.sessionStorage.getItem(componentName));
              // console.log(applications, 'application')
              applications.filter(application => {
                return application.AppID === this.appId
              }).forEach(element => {
                // console.log("element", element)
                let nextLevelId;
                if (this.selectedStatus.flag == 'A') {
                  nextLevelId = 'Farmer';
                } else if (this.selectedStatus.flag == 'RP') {
                  nextLevelId = 'Vendor'
                } else if (this.selectedStatus.flag == 'R') {
                  nextLevelId = 'N/A'
                }

                  // element.Status_Ar = this.selectedStatus.flag == 'A' ? 'A' : 'C',
                  element.Status_Ar = 'C',
                  element.Status = this.selectedStatus.flag == 'A' ? 'Approved' : (this.selectedStatus.flag == 'RP') ? 'Return Process' : (this.selectedStatus.flag == 'R') ? 'Rejected' : 'Marked Return',
                  element.NextLevelID = nextLevelId,
                  element.Remarks = this.remarks

                  // console.log(applications)

              });
              // sessionStorage.setItem('miVendorApplicationForApproval', JSON.stringify(applications));
              sessionStorage.setItem(componentName, JSON.stringify(applications));
            }

            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Vendor Application Processed Successfully.' });
            if(componentName == 'miVendorApplicationForApprovalPending'){
              this.router.navigate(['department', 'vendor-mi-applications', 'pending']);
            }
            else if(componentName == 'miVendorApplicationForApprovalCurrent'){
              this.router.navigate(['department', 'vendor-mi-applications', 'current']);
            }
          }
        },
        error: (err) => {
          this.loader.close();
          this.activityRecordService.activityRecord(this.userID, 'Submit Approval', this.appId, new Date(), err);
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Cannot Process the MI Estimation Application' });
        }
      });
  }


  proDataCalculation() {
    const tableDataToPush: any = [];
    this.applicationDetails?.EstimationComponentDetail.forEach((row) => {
      tableDataToPush.push({
        cat: JSON.stringify(row.CatID),
        component: row.ComponentName,
        size: row.Size,
        quantity: row.Quantity,
        price: JSON.stringify(row.Price)
      });
    });

    // if (!(this.finalEstimationControls?.rowSpacing?.errors?.required || this.finalEstimationControls?.plantSpacing?.errors?.required || this.finalEstimationControls?.MIArea?.errors?.required)) {
    // this.showProDataCalError = false;
    let finalDataToPost = {
      estimationComponentDetail: tableDataToPush,
      programId: this.applicationDetails?.ProgID,
      applicationId: this.applicationDetails?.AppID,
      vendorId: JSON.stringify(this.applicationDetails?.vendorRegId),
      rowSpacing: this.applicationDetails?.RowSpacing,
      plantSpacing: this.applicationDetails?.PlantSpacing,
      area: this.applicationDetails?.MIArea,
    }
    let reqBody = finalDataToPost;

    // console.log("final Data to post", reqBody)
    this.getMaxSubsidy(reqBody);
    // }

    // else {
    //   this.showProDataCalError = true;
    // }

  }

  getMaxSubsidy(reqBody) {
    this.loader.start();
    this.vendorService
      .getMaxSubsidyEstimate(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // console.log('getMaxSubsidy', data);
          this.proCalculatedData = data;
          this.loader.close();
          this.isProDataCalculated = true;
          // this.messageService.add({
          //   severity: 'info',
          //   summary: 'Status',
          //   detail: data,
          // });
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
        // complete: () => {
        //   this.messageService.add({
        //     severity: 'success',
        //     summary: 'Success',
        //     detail: 'Estimation Updated Successfully',
        //   });
        // },
      });
  }

  onClickApp() {
    let statusCodeEncrypted = this.cryptoJsService.Encrypt(this.statusCode);
    const link = this.router.serializeUrl(this.router.createUrlTree(['department', 'print', this.appId]));
    window.open(link, '_blank');
  }

  // onPrint(divName) {
  //   var printContents = document.getElementById(divName).innerHTML;
  //   var originalContents = document.body.innerHTML;
  //   document.body.innerHTML = printContents;
  //   window.print();
  //   document.body.innerHTML = originalContents;
  // }

  getPreEstimationData(appId, programId) {
    if (appId && programId) {
      this.deptDashBoardService
        .getApplicationDataOfPreEstimation(appId, programId)
        .pipe(first())
        .subscribe({
          next: (data) => {
            this.preEstimateDetails = data;

            if (
              this.preEstimateDetails.CropTypeID &&
              this.preEstimateDetails.CropId
            ) {
              this.cropType.forEach((res) => {
                if (res.data === data.CropTypeID) {
                  // this.selectedCropType = res.label;
                  let crop = res.children;
                  crop.forEach((res2) => {
                    if (res2.data === data.CropId) {
                      this.preEstimateDetails = {
                        ...data,
                        selectedCropType: res?.label,
                        selectedCrop: res2.label,
                      };
                      // this.selectedCrop = res2.label;
                    }
                  });
                  return;
                }
              });
            }

            if (this.preEstimateDetails.listGPSCoordinates.length > 0) {
              this.showMapPreEstimate = true;
              let locationArray = [];
              this.preEstimateDetails.listGPSCoordinates.forEach((e) => {
                locationArray.push({ lat: e.Latitude, lng: e.Longitude });
              });
              this.optionsPreEstimate = {
                center: {
                  lat: locationArray[0].lat,
                  lng: locationArray[0].lng,
                },
                zoom: 12,
                mapTypeId: google.maps.MapTypeId.SATELLITE,
              };
              let pointLocations = [];
              locationArray.forEach((e) => {
                pointLocations.push(
                  new google.maps.Marker({
                    position: { lat: e.lat, lng: e.lng },
                  })
                );
              });
              this.overlaysPreEstimate = [
                ...pointLocations,
                new google.maps.Polygon({
                  paths: [...locationArray],
                  strokeOpacity: 0.5,
                  strokeWeight: 1,
                  fillColor: '#1976D2',
                  fillOpacity: 0.35,
                }),
              ];

              this.preEstimateDetails = {
                ...this.preEstimateDetails,
                overlaysPreEstimate: this.overlaysPreEstimate,
                optionsPreEstimate: this.optionsPreEstimate,
              };
            } else {
              this.showMapPreEstimate = false;
            }

            this.preEstimationDataArray.push(this.preEstimateDetails);
            // console.log("helllllo", this.preEstimationDataArray);
          },
          error: () => {},
        });
    }
  }


  getApplicationDetails(appId) {
    this.loader.start();
    this._dashboardService.getApplicationByAppId(appId).subscribe((res) => {
      this.loader.close();
      if (res) {
        // this.applicationDetails = res;

        // res.ListViewFormData = [
        //   {
        //     "AutoId": 372819,
        //     "ProgId": 2,
        //     "VendorId": "302",
        //     "User_ID": "farmer"
        //   },
        //   {
        //     "AutoId": 372819,
        //     "ProgId": 2,
        //     "VendorId": "302",
        //     "User_ID": "farmer"
        //   }
        // ]

        if (res.ListViewFormData && res.ListViewFormData.length > 0) {
          res.ListViewFormData.forEach((val) => {
            let autoId = val?.AutoId;
            let progId = val?.ProgId;
            // let userId = val?.User_ID;
            // let vendorId = val?.VendorId;

            // if (autoId && userId) {
            //   this.getCalculatedSubsidyDataForMIPhys(autoId, userId);
            // }

            if (autoId && progId) {
              this.getPreEstimationData(this.appId, progId);
            }

            // if (this.appId && progId) {
            //   this.getSanctionLetterData(this.appId, progId);
            // }

            // if (vendorId && progId) {
            //   this.getMIEstimationData(this.appId, vendorId, progId);
            //   this.getMIBOQData(this.appId, vendorId, progId);
            // }

            // if (autoId && userId) {
            //   this.getPhysicalSurveyData(autoId, userId);
            // }
          });
        }

        // if (
        //   this.applicationDetails.FarmerLand &&
        //   this.applicationDetails.FarmerLand.length > 0
        // ) {
        //   this.applicationDetails.FarmerLand.forEach(
        //     (val) => (this.totalLandArea += parseFloat(val.totalArea))
        //   );
        // }

        // this.totalArea = 0;
        // if (this.applicationDetails?.New_MI_Datas.length > 0) {
        //   this.applicationDetails.New_MI_Datas.forEach(
        //     (val) => (this.totalArea += parseFloat(val.totalArea))
        //   );
        // }
        // let farmerId = res.Farmer_ID;
        // if (res?.GroupTableData) {
        //   this.getPastSubsidiesByMultipleFarmerIds(res?.GroupTableData);
        // } else {
        //   this.getPastSubsidiesByFarmerId(farmerId);
        // }
      }
    });
  }

  getCropMaster() {
    // this.loader.start();
    this.vendorService
      .getCropMaster()
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.cropType = res;
          // this.loader.close();
        },
        error: () => {
          // this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Crop Master not loaded.',
          });
        },
      });
  }
}